import { version } from '../version.js';
export async function fetchJSON(url, init) {
    const headers = new Headers(init?.headers);
    headers.set('user-agent', `@omni-network/core:${version}`);
    const _init = { ...init, headers };
    const res = await fetch(url, _init);
    const json = await res.json();
    if (!res.ok) {
        if (!isJSONError(json.error))
            new Error(`${res.status} ${res.statusText}`);
        throw json.error;
    }
    return json;
}
// TODO: use zod
function isJSONError(error) {
    const err = error;
    return (err != null &&
        typeof err.code === 'number' &&
        typeof err.status === 'string' &&
        typeof err.message === 'string');
}
//# sourceMappingURL=api.js.map